import { createUseStyles } from 'react-jss'

export default createUseStyles(theme => ({
  backButton: {
    float: 'left',
    marginLeft: 0,
  },
}))
